import React from "react";

const Header: React.FC = () => {
  return (
    <header className="flex items-center justify-center">
      <div className="relative flex items-baseline gap-1">
        <h1 className="font-display text-5xl font-bold text-rose-accent tracking-[0.15em]">
          Steph
        </h1>
        <div className="absolute -bottom-1 left-0 right-0 h-px bg-linear-to-r from-rose-accent/60 to-transparent" />
      </div>
    </header>
  );
};

export default Header;
